import {
  RAQ_PAGE_TYPE,
  RaqPageType,
  StorageLikesType,
} from "@components/utils/constants";
import DetailsPageWrapper from "@modules/detailsPage/DetailsPageWrapper";
import AccommodationPageTopSection from "@modules/detailsPage/topSections/AccommodationPageTopSection";
import ActivityPageTopSection from "@modules/detailsPage/topSections/ActivityPageTopSection";
import LocationPageTopSection from "@modules/detailsPage/topSections/LocationPageTopSection";
import PackagePageTopSection from "@modules/detailsPage/topSections/PackagePageTopSection";
import { RaQFormType } from "pages/things-to-do/[...slug]";
import { ITopNavigationResponse } from "../../types/commonResponses";
import {
  IAccommodationResponse,
  IActivityResponse,
  ILocationResponse,
  IPackageResponse,
  IRegionResponse,
} from "../../types/modelResponses";
import DetailsPageSectionsWrapper from "./DetailsPageSectionsWrapper";
import AccommodationOrActivityPageMainSection from "./mainSections/AccommodationOrActivityPageMainSection";
import PackagePageMainSection from "./mainSections/PackagePageMainSection";

export interface IDetailsPage {
  data:
    | IAccommodationResponse
    | ILocationResponse
    | IPackageResponse
    | IActivityResponse;
  region?: IRegionResponse;
  allPackages?: IPackageResponse | IPackageResponse[];
  allLocations?: ILocationResponse | ILocationResponse[];
  topNavigation: ITopNavigationResponse;
  raqFormType: RaQFormType;
  pageType: RaqPageType;
  likesType: StorageLikesType;
  openViewAllActivities?: (shouldOpen: boolean) => void;
  openViewAllAccommodations?: (shouldOpen: boolean) => void;
  viewAllActivities?: boolean;
  viewAllAccommodations?: boolean;
}

function DetailsPageTopContent({
  pageType,
  data,
  region,
}: Pick<IDetailsPage, "pageType" | "data" | "region">) {
  if (
    pageType === RAQ_PAGE_TYPE.ACCOMMODATION ||
    pageType === RAQ_PAGE_TYPE.ACTIVITY
  ) {
    return pageType === RAQ_PAGE_TYPE.ACCOMMODATION ? (
      <AccommodationPageTopSection data={data} region={region} />
    ) : (
      <ActivityPageTopSection data={data} />
    );
  } else if (pageType === RAQ_PAGE_TYPE.PACKAGE) {
    const currentData = data as IPackageResponse;

    return currentData.locations ? (
      <PackagePageTopSection data={data as IPackageResponse} />
    ) : (
      <LocationPageTopSection data={data as ILocationResponse} />
    );
  } else return null;
}

function DetailsPageContent({
  pageType,
  data,
  allLocations,
  allPackages,
  viewAllAccommodations,
  openViewAllAccommodations,
  viewAllActivities,
  openViewAllActivities,
}: Pick<
  IDetailsPage,
  | "pageType"
  | "data"
  | "allPackages"
  | "allLocations"
  | "openViewAllAccommodations"
  | "openViewAllActivities"
  | "viewAllAccommodations"
  | "viewAllActivities"
>) {
  if (
    pageType === RAQ_PAGE_TYPE.ACCOMMODATION ||
    pageType === RAQ_PAGE_TYPE.ACTIVITY
  ) {
    return (
      <AccommodationOrActivityPageMainSection
        data={data}
        allPackages={allPackages}
        allLocations={allLocations}
        pageType={pageType}
      />
    );
  } else if (pageType === RAQ_PAGE_TYPE.PACKAGE) {
    return (
      <PackagePageMainSection
        data={data as IPackageResponse | ILocationResponse}
        openViewAllActivities={
          openViewAllActivities as (shouldOpen: boolean) => void
        }
        openViewAllAccommodations={
          openViewAllAccommodations as (shouldOpen: boolean) => void
        }
        viewAllAccommodations={viewAllAccommodations}
        viewAllActivities={viewAllActivities}
      />
    );
  } else return null;
}

function DetailsPage({
  data,
  region,
  allPackages,
  allLocations,
  topNavigation,
  raqFormType,
  pageType,
  likesType,
  openViewAllActivities,
  openViewAllAccommodations,
  viewAllActivities,
  viewAllAccommodations,
}: IDetailsPage): JSX.Element {
  return (
    <DetailsPageWrapper data={data} likesType={likesType} pageType={pageType}>
      <DetailsPageSectionsWrapper
        data={data}
        topNavigation={topNavigation}
        raqFormType={raqFormType}
        pageType={pageType}
      >
        <DetailsPageTopContent
          pageType={pageType}
          data={data}
          region={region}
        />
        <DetailsPageContent
          pageType={pageType}
          data={data}
          allLocations={allLocations}
          allPackages={allPackages}
          openViewAllAccommodations={openViewAllAccommodations}
          openViewAllActivities={openViewAllActivities}
          viewAllAccommodations={viewAllAccommodations}
          viewAllActivities={viewAllActivities}
        />
      </DetailsPageSectionsWrapper>
    </DetailsPageWrapper>
  );
}

export default DetailsPage;
